import script from "./CardDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDelivery.vue?vue&type=script&setup=true&lang=js"

import "./CardDelivery.vue?vue&type=style&index=0&id=b598a80a&lang=css"

const __exports__ = script;

export default __exports__